import useGlobalStore from '@/store/useGlobalStore'
import { useEffect, useState } from 'react'
import { getIsThereEnoughTimeForItemToShip } from '../getIsThereEnoughTimeForItemToShip'

export const useGetIfThereIsEnoughTimeToShip = () => {
  const {
    app: {
      addProductToSubscription: { selectedSubscriptionId },
    },
    subscriptions,
  } = useGlobalStore()

  const [isThereEnoughTimeToShip, setIsThereEnoughTimeToShip] = useState<
    boolean | null
  >(null)

  useEffect(() => {
    if (!subscriptions || !subscriptions.items || !selectedSubscriptionId) {
      setIsThereEnoughTimeToShip(null)
      return
    }

    const selectedSubscription = subscriptions.items.find(
      (subscription) => subscription.id.unicity === selectedSubscriptionId,
    )

    if (!selectedSubscription) return

    setIsThereEnoughTimeToShip(
      getIsThereEnoughTimeForItemToShip({ subscription: selectedSubscription }),
    )
  }, [selectedSubscriptionId])

  return { isThereEnoughTimeToShip }
}
